<template>
  <div class="training-manual-card">
    <div class="title">
      {{ title }}
    </div>
    <div class="card-content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "TrainingManualCard",
  props: {
    title: String
  }
};
</script>
<style lang="scss">
.training-manual-card {
  width: 100%;
  background: #fff;
  border-radius: 9px;
  padding: 12px 18px;
  .title {
    font-size: 18px;
    color: #3d3d3d;
  }
  .card-content {
    margin-top: 18px;
    font-size: 14px;
    color: #3d3d3d;
  }
}
</style>
